export default __webpack_public_path__ + "static/media/image4.090d0735.png";